
import SockJS from 'sockjs-client'
import WebStomp from 'webstomp-client'

export default {
  name: 'MarketPriceTable',
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    tableSymbol: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      baseUrl: process.env.NUXT_APP_PANEL_BASE_URL,
      stompClient: null,
      tab: 0,
      page: 1,
      searchData: '',
      selected: [],
      sparkline: {
        lineWidth: 2,
        radius: 25,
        padding: 0,
        height: 20,
        width: 64,
        lineCap: 'round',
        gradients: [
          ['#fff'],
          ['rgba(4, 178, 131, 0.1)'],
          ['rgba(241, 80, 87, 0.1)'],
        ],
        gradientDirection: 'top',
        fill: true,
        type: 'trend',
        autoLineWidth: false,
      },
      tableHeaders: [
        {
          text: this.$t('landingPage.pricesList.table.name'),
          value: 'name',
          align: 'start',
          width: 200,
          sortable: false,
          class: 'table-header-title',
          cellClass: 'table-cell',
        },
        {
          text: this.$t('landingPage.pricesList.table.lastPrice'),
          value: 'lastPrice',
          align: 'start',
          width: 200,
          sortable: false,
          class: 'table-header-title',
          cellClass: 'table-cell',
        },
        {
          text: this.$t('landingPage.pricesList.table.change'),
          value: 'change',
          align: 'start',
          width: 200,
          sortable: false,
          class: 'table-header-title',
          cellClass: 'table-cell',
        },
        {
          text: this.$t('landingPage.pricesList.table.chart'),
          value: 'chart',
          align: 'start',
          width: 200,
          sortable: false,
          class: 'table-header-title',
        },
        {
          text: this.$t('landingPage.pricesList.table.volume'),
          value: 'marketCap',
          align: 'start',
          width: 200,
          sortable: false,
          class: 'table-header-title',
          cellClass: 'table-cell',
        },
        {
          value: 'operation',
          align: 'center',
          width: 100,
          sortable: false,
          class: 'table-header-title',
          cellClass: 'table-cell',
        },
      ],
      tableHeadersMobile: [
        {
          text: this.$t('landingPage.pricesList.table.name'),
          value: 'name',
          align: 'left',
          width: 100,
          sortable: false,
          class: 'table-header-title',
          cellClass: 'table-cell',
        },
        {
          text: this.$t('landingPage.pricesList.table.priceChange'),
          value: 'lastPrice',
          align: 'right',
          width: 100,
          sortable: false,
          class: 'table-header-title',
          cellClass: 'table-cell',
        },
      ],
      tableBody: [],
    }
  },
  async fetch() {
    this.tableBody = await this.filterByBaseCoin();
  },
  computed: {
    filteredTableData() {
      return this.tableBody.filter(
        (item) =>
          item.symbol.toLowerCase().indexOf(this.searchData.toLowerCase()) === 0
      )
    },
    // favorites() {
    //   return this.tableData.filter((item) => item.favored)
    // },
  },
  mounted() {
    const socket = new SockJS(
      process.env.NUXT_APP_API_BASE_URL + '/market/market-ws'
    )
    this.stompClient = WebStomp.over(socket)
    this.initWebSocket()
  },
  methods: {
    initWebSocket() {
      this.stompClient.debug = () => {
      }
      this.stompClient.connect({}, this.onWebSocketConnect)
    },
    onWebSocketConnect() {
      this.stompClient.subscribe('/topic/market/thumb', (msg) => {
        this.handleMarketsSocketData(JSON.parse(msg.body))
      })
    },
    handleMarketsSocketData(data) {
      this.tableData.forEach((elem) => {
        if (data.symbol === elem.symbol) {
          elem.close = data.close
          elem.chg = data.chg
          elem.high = data.high
          elem.low = data.low
          elem.volume = data.volume
          elem.twentyFourHourVolume = data.twentyFourHourVolume
        }
      })
      this.changeTab()
    },
    thousandMask(num) {
      num += ''
      const x = num.split('.')
      let x1 = x[0]
      const x2 = x.length > 1 ? '.' + x[1] : ''
      const rgx = /(\d+)(\d{3})/
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2')
      }
      return x1 + x2
    },
    filterByBaseCoin() {
      return this.tableData.filter((item) =>
        item.symbol.split('/')[1].includes(this.tableSymbol[this.tab])
      )
    },
    changeTab() {
      // this.tableBody =
      //   this.tableSymbol[this.tab] === 'Favorites'
      //     ? this.favorites
      //     : this.filterByBaseCoin()
      this.tableBody = this.filterByBaseCoin()
    },
    // checkForFavored(coin) {
    //   const formData = new FormData()
    //   formData.append('symbol', coin.symbol)
    //   if (coin.favored) {
    //     this.deleteFromFavorites(formData)
    //   } else {
    //     this.addToFavorites(formData)
    //   }
    // },
    // addToFavorites(formData) {
    //   this.$store
    //     .dispatch('markets/addToFavorites', formData)
    //     .then((response) => {
    //       if (response.data.code === 0) {
    //         this.tableBody.forEach((item) => {
    //           if (item.symbol === formData.get('symbol')) {
    //             item.favored = true
    //           }
    //         })
    //       }
    //     })
    // },
    // deleteFromFavorites(formData) {
    //   this.$store
    //     .dispatch('markets/deleteFromFavorites', formData)
    //     .then((response) => {
    //       if (response.data.code === 0) {
    //         this.tableBody.forEach((item) => {
    //           if (item.symbol === formData.get('symbol')) {
    //             item.favored = false
    //           }
    //         })
    //       }
    //     })
    // },
    goToExchange(data) {
      if (this.$vuetify.breakpoint.smAndDown) {
        window.location =
          this.baseUrl +
          `/exchange/` +
          data.symbol.split('/')[0].toLowerCase() +
          `_` +
          data.symbol.split('/')[1].toLowerCase()
      }
    },
  },
}
